// extracted by mini-css-extract-plugin
export var skipLink = "fq_t2";